<p-tabView>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span class="tab-header"><i class="fa fa-user-cog mr-3"></i>Allgemein</span>
        </ng-template>
        <div class="dialog-container">
            <div class="grid p-fluid p-input-filled dialog-row">
                <div class="col-6">
                    <span class="p-float-label">
                        <input type="text" [(ngModel)]="user.userName" pInputText [ngClass]="{'ng-invalid ng-dirty': isUserNameInvalid}">
                        <label>Benutzername *</label>
                    </span>
                    <small *ngIf="isUserNameInvalid" class="p-error">{{userNameValidationMessage}}</small>
                </div>
            </div>
            <div class="grid p-fluid p-input-filled dialog-row">
                <div class="col-6">
                    <span class="p-float-label">
                        <input type="text" [(ngModel)]="user.firstName" pInputText>
                        <label>Vorname</label>
                    </span>
                </div>
                <div class="col-6">
                    <span class="p-float-label">
                        <input type="text" [(ngModel)]="user.lastName" pInputText [ngClass]="{'ng-invalid ng-dirty': isLastNameInvalid}">
                        <label>Nachname *</label>
                    </span>
                    <small *ngIf="isLastNameInvalid" class="p-error">Nachname ist erforderlich (mindestens 2 Zeichen)</small>
                </div>
            </div>
            <div class="grid p-fluid p-input-filled dialog-row">
                <div class="col-6">
                    <div class="field-checkbox">
                        <p-checkbox [(ngModel)]="isActive" [binary]="true" [disabled]="(currentUser.isAdmin === false)"></p-checkbox>
                        <label style="font-size: 18px;">Aktiv</label>
                    </div>
                </div>
            </div>
        </div>
    </p-tabPanel>
</p-tabView>
<div style="text-align: right;">
    <p-button icon="fa fa-times" label="Abbrechen" styleClass="p-button-text p-button-danger p-button-lg" (onClick)="cancelAsync()"></p-button>
    <p-button icon="fa fa-check" label="Speichern" styleClass="p-button-text p-button-success p-button-lg" [disabled]="(canSave === false)" (onClick)="saveAsync()"></p-button>
</div>
